module.exports = __webpack_public_path__ + "static/media/lady2.0a1158e7.gif";